export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },

      {
        _name: 'CSidebarNavTitle',
        _children: ['Polygon Management']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Ports',
        to: '/ports',
        icon: 'cil-globe-alt'
      },
    ]
  }
]
